import React, { createElement as _createElement } from 'react';
import { ElementRenderer } from "../index.js";
import { FormCheckbox } from "../../../formCheckbox/FormCheckbox.js";
import { FormLayout } from "../../../formLayout/FormLayout.js";
import { Skeleton } from "../../../skeleton/Skeleton.js";
import { useFormContext } from "../../context/FormContext/index.js";
import { useCustomRule } from "../../hooks/useCustomRule.js";
import { useDefaultValueValidation } from "../../hooks/useDefaultValueValidation.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomFormCheckbox({
  element,
  control,
  useSmallFields,
  isFormDisabled,
  isLoading
}) {
  useCustomRule(element.customRuleFn);
  const formContext = useFormContext();
  useDefaultValueValidation(formContext, element.id);
  const checkboxProps = {
    ...element.componentProps,
    disabled: isFormDisabled
  };
  return /*#__PURE__*/_jsx(FormLayout, {
    spacing: true,
    children: /*#__PURE__*/_jsx(Skeleton, {
      loading: isLoading,
      width: "150px",
      children: /*#__PURE__*/_jsx(FormCheckbox, {
        control: control,
        name: element.id,
        rules: element.setRules?.(formContext),
        defaultValue: element.componentProps.checked,
        checkboxProps: checkboxProps,
        children: element.componentProps.children.map((child, index) => {
          if (typeof child === 'string') {
            return child;
          }
          return /*#__PURE__*/_createElement(ElementRenderer, {
            element: child,
            control,
            isFormDisabled,
            useSmallFields,
            key: index
          });
        })
      })
    })
  });
}